<app-form-field [required]="true">
  <label class="text-[14px]!" app-label translate>trilhas.estudio.trilha.anexo-principal</label>
  <app-upload-file
    [image]="preview"
    class="w-full"
    [config]="config"
    [invalid]="submitted && form.controls.file.invalid"
    (statusChange)="onUpload($event)"
  ></app-upload-file>
  @if (submitted && form.controls.file.invalid) {
    <span app-error translate>geral.erros.required</span>
  }
</app-form-field>
